import React, { useState } from 'react';
import { session } from '../../../Service/APIService';
import ModalCBChange from '../../Custom/ModalCBChange';
import AuthModal from '../../Custom/AuthModal';
import { withRouter } from 'react-router-dom';
import ModalDIOperations from '../../Common/ModalWithRadioButtons';

const MenuItems = (props) => {
  const [selectedCB, setSelectedCB] = useState({
    assetToDiSettingId: 0,
    DeviceId: 0,
  });
  const [showCBModal, setShowCBModal] = useState(false);
  const [authDetails, setAuthDetails] = useState({ isShow: false, data: {} });

  const isDOItemDisabled = () => {
    if (props?.selectedAsset?.className !== 'breaker') return true;
    if (!props?.selectedAsset?.diData) return true;

    const { ControlAssetReq, DICurrentStatusText } =
      props?.selectedAsset?.diData;
    const DoublePoint = props?.selectedAsset?.DoublePoint;
    return (
      ControlAssetReq === 0 ||
      (DoublePoint === true &&
        (DICurrentStatusText === 'INVALID' ||
          DICurrentStatusText === 'INTERMEDIATE'))
    );
  };

  const isSBOItemDisabled = () => {
    if (props?.selectedAsset?.className !== 'breaker') return true;
    if (!props?.selectedAsset?.diData) return true;

    const { IsSBOSupported, DICurrentStatusText } =
      props?.selectedAsset?.diData;
    const DoublePoint = props?.selectedAsset?.DoublePoint;
    return (
      IsSBOSupported === 0 ||
      (DoublePoint === true &&
        (DICurrentStatusText === 'INVALID' ||
          DICurrentStatusText === 'INTERMEDIATE'))
    );
  };

  const handleSeeDetailClick = () => {
    const { SubstationId: assetpointId, divId = 0 } = props;

    switch (props?.selectedAsset.className) {
      case 'breaker':
        props.history.push(
          `/eereportsnew?${btoa(
            `divId=${divId}&asptId=${Number(assetpointId)}&asstId=${
              props?.selectedAsset.data.AssetId
            }`
          )}`
        );
        break;
      case 'transformer':
        props.history.push(
          `/assetreports?${btoa(
            `divId=${divId}&asptId=${Number(assetpointId)}&asstId=${
              props?.selectedAsset.assetId
            }`
          )}`
        );
        break;
      case 'battery':
        props.history.push(
          `/assetreports?${btoa(
            `divId=${divId}&asptId=${Number(assetpointId)}`
          )}`
        );
        break;
      default:
        break;
    }
  };

  const handleAuthClick = (data) => {
    if (data) {
      if (Object.keys(data).length > 0) {
        const { assetDISettingId, DeviceId: deviceId } = data;
        setSelectedCB({ assetDISettingId, deviceId });
        setShowCBModal(true);
      } else {
        alert('No data');
      }
    }
  };

  const handleAssetClick = () => {
    const userInfo = session.user();
    const { data, assetDISettingId } = props?.selectedAsset;
    if (userInfo.roleId === 1 || userInfo.roleId === 2) {
      //skip auth for role superuser and client admin
      // eslint-disable-next-line no-prototype-builtins
      if (props?.selectedAsset.hasOwnProperty('data')) {
        handleAuthClick({ ...data, assetDISettingId });
      }
    } else {
      setAuthDetails({ isShow: true, data: { assetDISettingId, ...data } });
    }
  };

  const onSubmitAuthSuccess = (data) => {
    setAuthDetails({ ...authDetails, isShow: false });
    handleAuthClick(data);
  };

  const onMenuItemClick = (name) => {
    switch (name) {
      case 'Select Before Operate':
      case 'Direct Operate Asset':
        handleAssetClick();
        break;
      case 'See Details':
        handleSeeDetailClick();
        break;
      default:
        return '';
    }
  };

  const hide = () => {
    setShowCBModal(false);
    setSelectedCB({ assetToDiSettingId: 0, DeviceId: 0 });
    props.fetchSLDValues();
  };

  return (
    <React.Fragment>
      {/* <Menu id={props.menuId} animation={animation.zoom}>
        <Item
          onClick={(e) => onMenuItemClick(e, 'Select Before Operate')}
          disabled={isSBOItemDisabled}
        >
          Select Before Operate
        </Item>
        <Item
          onClick={(e) => onMenuItemClick(e, 'Direct Operate Asset')}
          disabled={isDOItemDisabled}
        >
          Direct Operate Asset
        </Item>
        <Item onClick={(e) => onMenuItemClick(e, 'See Details')}>
          See Details
        </Item>
      </Menu> */}

      <ModalDIOperations
        isDOItemDisabled={isDOItemDisabled()}
        isSBOItemDisabled={isSBOItemDisabled()}
        show={props.showOperationModal}
        onHide={props.hideOperationModal}
        onSelect={(selectedOption) => onMenuItemClick(selectedOption)}
      />

      {showCBModal && (
        <ModalCBChange
          deviceId={selectedCB.deviceId}
          assetToDiSettingId={selectedCB.assetDISettingId}
          hide={hide}
        />
      )}
      {authDetails.isShow && (
        <AuthModal
          onDismissClick={() =>
            setAuthDetails({
              ...authDetails,
              isShow: !authDetails.isShow,
            })
          }
          onSubmitSuccess={() => onSubmitAuthSuccess(authDetails.data)}
        />
      )}
    </React.Fragment>
  );
};

export default withRouter(MenuItems);
